module.exports = __webpack_public_path__ + "media/manage-seamlessly.7bb51c58.svg";